import { useCallback, useEffect, useRef } from 'react';

import { throttle } from '@/helpers/throttle';

export function useThrottle<T extends (...args: any[]) => any>(
	callback: T,
	delayMs: number = 300,
) {
	const callbackRef = useRef<T>(callback);

	// This is run intentionally without the depdencies and will update after each rerender
	useEffect(() => {
		callbackRef.current = callback;
	});

	// eslint-disable-next-line react-hooks/exhaustive-deps
	return useCallback(
		throttle((...args: any[]) => callbackRef.current(...args), delayMs),
		[delayMs],
	);
}
